import { dashboard } from 'src/app/models';

export function isDashboardEditable(
  dashboard: dashboard,
  isUserRootAccess: boolean = false,
  isUserPartner: boolean = false,
  isUserAllowedToEditOtherUsersDashboards: boolean = false,
  isReadOnly: boolean = false): boolean {
    if(isReadOnly) return false;
    return dashboard.userOwned || dashboard.isPublic && (isUserRootAccess || isUserPartner || isUserAllowedToEditOtherUsersDashboards && dashboard.allowNonOwnersToEdit);
}

export function isAllowedToChangeDashboardAccess(
  dashboard: dashboard,
  isUserRootAccess: boolean = false,
  isUserPartner: boolean = false,
  isUserAllowedToEditOtherUsersDashboards: boolean = false,
  isReadOnly: boolean = false): boolean {
    if(isReadOnly) return false;
    return isUserRootAccess || isUserPartner || dashboard.userOwned || dashboard.isPublic && isUserAllowedToEditOtherUsersDashboards && dashboard.allowNonOwnersToEdit;
}
